import { WarningOutlined } from "@ant-design/icons";
import { Flex, Modal, theme } from "antd";
import { useTranslation } from "react-i18next";
import { useDeleteChartMutation } from "../../graphql/mutation.deleteChart";
import { Chart } from "../../graphql/query.charts";

type DeleteChartModalProps = {
  chart: Chart;
  onSuccess: (deletedChartId: string) => void;
  onError: (error: unknown) => void;
  onCancel: () => void;
};

export const DeleteChartModal = ({
  chart,
  onSuccess,
  onError,
  onCancel,
}: DeleteChartModalProps) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const [runDeleteChart, { loading: isDeleteChartLoading }] =
    useDeleteChartMutation();

  const handleDeleteChart = async (chart: Chart) => {
    try {
      const response = await runDeleteChart({
        variables: {
          input: {
            chartID: chart.id,
          },
        },
      });
      if (response.data) {
        onSuccess(response.data.deleteChart.deletedChartID);
      } else {
        throw new Error("Chart deletion failed");
      }
    } catch (error: unknown) {
      onError(error);
    }
  };

  return (
    <Modal
      title={
        <Flex gap={8}>
          <WarningOutlined style={{ color: token.colorError }} />
          {t("confirm_delete_title")}
        </Flex>
      }
      open={true}
      onOk={() => handleDeleteChart(chart)}
      okText={t("yes")}
      cancelText={t("no")}
      confirmLoading={isDeleteChartLoading}
      onCancel={onCancel}
      cancelButtonProps={{
        disabled: isDeleteChartLoading,
      }}
      okButtonProps={{
        danger: true,
      }}
      centered={true}
      closable={false}
    >
      <p>{t("confirm_delete_content")}</p>
    </Modal>
  );
};
